<template>
  <div class="bg" >
    <v-nav></v-nav>
    <mode v-if="loadMode" class="modeapp"></mode>
    <div class="introducePage">
      <div class="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in photoList">
            <div class="photo">
              <img :src="item.img" :alt="item.nick_name">
            </div>
            <div class="name">{{item.nick_name}}</div>
            <div class="introduce_txt" v-html="item.describe"></div>
          </div>
        </div>
        <div class="swiper-pagination pages"></div>
        <div class="lookmore">右滑查看更多内容&gt;&gt;</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from '../../../public/swiper/swiper-bundle.min';
  import mode from '@/components/bg/mode'
    export default {
        name: "introduce",
        components:{
          mode
        },
        data() {
            return {
              loadMode:true,
              photoList:[],
              index:0
            }
        },
        mounted() {
          this.getList()
        },
        methods: {
          getList(){
            this.$http({
              url: '/Ancestor/list',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {ajax:1}
            }).then((res) => {
              this.loadMode=false
              console.log(res)
              this.loadMode=false
              if(res.data.code==0){
                this.photoList=res.data.data
                var swiper = new Swiper(".swiper", {
                  initialSlide :0,		//轮播开始位置
                  observer:true,			//轮播元素为内部动态添加必须加此 修改swiper自己或子元素时，自动初始化swiper
                  observeParents:true,	//轮播元素为内部动态添加必须加此 修改swiper的父元素时，自动初始化swiper
                  slidesPerView: 1,
                  spaceBetween: 30,
                  pagination: {
                    el: ".swiper-pagination",
                    bulletClass : 'swiper-pagination-bullet bulldefault',
                    bulletActiveClass: 'bullet-active-currents',
                  },
                });
                if(this.$route.query.id){
                  swiper.slideTo(this.$route.query.id)
                }
              }else{
                this.$layer.msg(res.data.msg)
              }
            })
            .catch((error) => {
              // error
              this.loadMode=false
              console.log(error)
            })

          },
        }
    }
</script>
<style>
  .pages{
    bottom:0.5rem !important;
  }
  .bulldefault{
    background: #c9a168 !important;
    border:1px solid #fff !important;
    box-sizing: border-box !important;
    opacity: 1 !important;
  }
  .bullet-active-currents{
    background: #5f4009 !important;
    border:1px solid #fff !important;
  }
</style>
<style scoped lang="scss">
  .bg{
    background: url("../../assets/images/phone/bg.jpg")no-repeat left bottom;
    position: fixed;
    top:0;
    min-height: 100%;
    left:0;
    right:0;
    bottom:0;
    overflow: hidden;
    background-size:100% 100%;
  }
  .introducePage{
    height:calc(100% - 1rem);
    padding:0.6rem 0.28rem;
    box-sizing: border-box;
    .swiper{
      height:100%;
      .swiper-wrapper{
        height:90%;
        .swiper-slide{
          background: #e8d9c5;
          border-radius:3px;
          height:100%;
          .photo{
            padding-top:0.4rem;
            img{
              width:1.3rem;
              max-height:1.8rem;
              display: block;
              margin:0 auto;
            }
          }
          .name{
            text-align: center;
            font-size:0.32rem;
            color:#5f4009;
            padding:0.15rem 0;
            line-height: 0.32rem;
          }
          .introduce_txt{
            height:calc(100% - 3rem);
            overflow: auto;
            color:#5f4009;
            font-size:0.28rem;
            line-height: 0.56rem;
            padding:0 0.26rem;
            box-sizing: border-box;
          }
        }

      }
      .lookmore{
        position: absolute;
        bottom:0;
        text-align: center;
        color:#5f4009;
        font-size:0.28rem;
        width:100%;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/m/introduce.vue